import type { ReactNode } from "react";
import { R } from "../orderingTheme";

interface TablesEmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
}

export const TablesEmptyState = ({
  icon,
  title,
  description,
}: TablesEmptyStateProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        padding: "32px 20px",
        fontFamily: R.font,
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 16,
          background: R.brandTint,
          color: R.brandDeep,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 26,
          border: "1px solid rgba(217,119,6,0.18)",
        }}
      >
        {icon}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <div
          style={{
            fontSize: 16,
            fontWeight: 700,
            letterSpacing: -0.3,
            color: R.ink,
            lineHeight: 1.2,
          }}
        >
          {title}
        </div>
        {description && (
          <div
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: R.textSoft,
              lineHeight: 1.5,
              maxWidth: 260,
            }}
          >
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
